import { Birthday } from '@tovala/browser-apis-combinedapi'

export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const

export const DAYS_IN_MONTH: Record<number, number> = {
  1: 31,
  // Allow Feb 29 — birthdays don't carry a year, so leap-year birthdays must be storable.
  2: 29,
  3: 31,
  4: 30,
  5: 31,
  6: 30,
  7: 31,
  8: 31,
  9: 30,
  10: 31,
  11: 30,
  12: 31,
}

export function formatBirthday({ day, month }: Birthday): string {
  return `${MONTH_NAMES[month - 1]} ${day}`
}

export function validateBirthday({
  day,
  month,
}: {
  day: number
  month: number
}): { valid: true } | { reason: string; valid: false } {
  if (!Number.isInteger(month) || month < 1 || month > 12) {
    return { valid: false, reason: 'Month must be between 1 and 12.' }
  }

  const maxDay = DAYS_IN_MONTH[month]
  if (!Number.isInteger(day) || day < 1 || day > maxDay) {
    return {
      valid: false,
      reason: `Day must be between 1 and ${maxDay} for month ${month}.`,
    }
  }

  return { valid: true }
}
